// extracted by mini-css-extract-plugin
export var loadingSpinner = "_1s-0";
export var spinnerContainer = "_1s-1";